// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"sQ-z","categoryName":"tQ-z","categoryNameSearchHeader":"uQ-z","categoryContent":"vQ-z","bottomAligned":"wQ-z","image":"xQ-z","imageNoBackground":"yQ-z"};